// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable semi */
import Vue from 'vue';
import App from '@/App';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/css/element-variables.scss'
import VueI18n from 'vue-i18n';
// Sas ライブラリ
import { ApiClientFactory, AsyncValidatorAlterer } from '@/core/libs';
import { DecoratorConfigs } from '@/core/decorators';
// vue2-perfect-scrollbar
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
// Application層
import router from '@/router';
import store from '@/store';
import lang from '@/lang';
import decoratorConfigs from '@/config/decorator';
import apiFactories from '@/api/factories';
import AppPlugin from '@/app/AppPlugin';
import * as filters from '@/app/filters';

Vue.config.productionTip = false;

// 国際化対応
const locale = 'ja';

// 国際化（メッセージリソース：静的データ管理）設定
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: locale,
  messages: lang
});

// element-ui設定
Vue.use(ElementUI, {
  locale: {
    el: lang[locale].el
  }
});

// PerfectScrollbarを共通コンポーネントとして登録
Vue.component('PerfectScrollbar', PerfectScrollbar);

// SaS設定 API設定
ApiClientFactory.registFactories(apiFactories);

// SaS設定 バリデータ拡張
AsyncValidatorAlterer.invoke({
  noLabel: true,
  messages: lang[locale].validator,
  rules: {}
});

// SaS設定 デコレータ設定
DecoratorConfigs.setConfigs(decoratorConfigs);

// アプリ専用プラグイン
Vue.use(AppPlugin);

// filter定義
for (const filter in filters) {
  Vue.filter(filter, filters[filter]);
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js